export enum AllocationOptions {
  paySetItems = "paySetItems",
  payAccount = "payAccount",
  setAmount = "setAmount",
  accountCredit = "accountCredit"
}
